import * as React from "react";
import * as main from "../../main.module.scss";
import * as vid from "./style.module.scss";
import data from "./data.json";
export const RevsVids = () => {
  const swiperVidsEl = React.useRef();
  React.useEffect(() => {
    if (swiperVidsEl.current) {
      Object.assign(swiperVidsEl.current, {
        slidesPerView: 1,
        spaceBetween: 5,
        navigation: {
          nextEl: '.swiper-btn-next',
          prevEl: '.swiper-btn-prev',
        },
        breakpoints: {
          660: {
            slidesPerView: 1,
            spaceBetween: 20,
          },

          1100: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
      });
      swiperVidsEl.current.initialize();
    }
  }, []);
  return (
    <section className={vid.vid}>
      <div className="container" style={{ position: "unset" }}>
        <h2 className={main.title}>Нас вдохновляют и поддерживают <span className={main.red}>результаты и&nbsp;отзывы</span> учеников</h2>
        <swiper-wrapper style={{ position: "relative" }}>
          <swiper-container ref={swiperVidsEl} init="false">
            {data.map((elem, index) => (
              <swiper-slide key={index}>
                <div className={vid.wrap}>
                  <div className={vid.bg}>
                    <iframe src={elem.src} title="Видео Advance" frameBorder="0"/>
                  </div>
                </div>
              </swiper-slide>
            ))}
          </swiper-container>
          <div className={vid.swiperButtons}>
            <button
              aria-label="swiper-btn-prev"
              className={`swiper-btn-prev ${vid.swiperBtnPrev}`}
            >
              <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="25" cy="25" r="24.6875" stroke="#7000E3" strokeWidth="0.625"/>
                <path d="M27.5 30L22.5 25L27.5 20" stroke="#7000E3" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <button
              aria-label="swiper-btn-next"
              className={`swiper-btn-next ${vid.swiperBtnNext}`}
            >
              <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="25" cy="25" r="24.6875" transform="matrix(-1 0 0 1 50 0)" stroke="#7000E3" strokeWidth="0.625"/>
                <path d="M22.5 30L27.5 25L22.5 20" stroke="#7000E3" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </swiper-wrapper>
      </div>
    </section>
  );
};
